module.exports = __webpack_public_path__ + "static/img/gini.7ad5949.gif";


//////////////////
// WEBPACK FOOTER
// ./static/gini/images/gini.gif
// module id = 3kf1
// module chunks = 34